import { FC, useMemo } from 'react';
import { Button, Spin, Table } from 'antd';
import { useModal } from '@ebay/nice-modal-react';

import { PackageInventoryItem } from '../../queries/api/types';
import InventoryDetailsDrawer from './InventoryDetailsDrawer';
import { GroupedInventory, useGroupedInventories } from './useGroupedInventories';

import './InventoryHistory.less';

const InventoryHistory: FC = () => {
    const inventoryDetailsDrawer = useModal(InventoryDetailsDrawer);
    const { storeId, loading, groupedInventories, packageLabelById, packageCodeById } = useGroupedInventories();

    const columns = useMemo(() => {
        const cols: any[] = [
            {
                title: 'Date',
                dataIndex: 'date',
                key: 'date',
            },
        ];

        if (!storeId) {
            cols.push({
                title: 'Magasin',
                dataIndex: 'storeName',
                key: 'storeName',
            });
        }

        cols.push({
            title: 'Utilisateur',
            dataIndex: 'storeUserName',
            key: 'storeUserName',
        });

        cols.push({
            title: 'Nb emballages inventoriés',
            dataIndex: 'packagesInventory',
            key: 'count',
            render: (items: PackageInventoryItem[]) => items?.length ?? 0,
        });

        cols.push({
            title: 'Action',
            key: 'action',
            render: (_: any, record: GroupedInventory) => (
                <Button
                    size="small"
                    type="primary"
                    onClick={() => {
                        inventoryDetailsDrawer.show({
                            data: {
                                date: record.rawDate,
                                storeName: record.storeName,
                                storeUserName: record.storeUserName,
                                packagesInventory: record.packagesInventory,
                                packageLabelById,
                                packageCodeById,
                            },
                        });
                    }}
                >
                    Détails
                </Button>
            ),
        });

        return cols;
    }, [storeId, inventoryDetailsDrawer, packageLabelById, packageCodeById]);

    return (
        <div className="inventory-history-page">
            <h1>Historique des inventaires</h1>

            {loading ? (
                <div className="inventory-history-loading">
                    <Spin />
                </div>
            ) : (
                <Table columns={columns} dataSource={groupedInventories} rowKey="key" pagination={{ pageSize: 20 }} />
            )}
        </div>
    );
};

export default InventoryHistory;
